import { render } from "./AttributeListing.vue?vue&type=template&id=0079500b&scoped=true"
import script from "./AttributeListing.vue?vue&type=script&lang=js"
export * from "./AttributeListing.vue?vue&type=script&lang=js"

import "./AttributeListing.vue?vue&type=style&index=0&id=0079500b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0079500b"],['__file',"src/components/attribute/AttributeListing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0079500b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0079500b', __exports__)) {
    api.reload('0079500b', __exports__)
  }
  
  module.hot.accept("./AttributeListing.vue?vue&type=template&id=0079500b&scoped=true", () => {
    api.rerender('0079500b', render)
  })

}


export default __exports__